<template>
  <div class="page-container">
    <div class="tools invisible" ref="stepTools">
      <FeatherIcon title="Complete step" icon="CheckCircleIcon" class="tool text-success" style="position:unset;"></FeatherIcon>
      <FeatherIcon title="Flag step" icon="FlagIcon" class="tool text-danger" style="position:unset;"></FeatherIcon>
      <FeatherIcon title="Find Element" icon="CrosshairIcon" class="tool text-primary" style="position:unset;"></FeatherIcon>
      <FeatherIcon title="Show Screen" icon="MonitorIcon" class="tool text-primary" style="position:unset;"></FeatherIcon>
    </div>
    <div class="full-height">
      <h1 v-if="CurrentOnboarding && CurrentOnboarding.name" class="title">
        {{CurrentOnboarding.name}}
      </h1>
      <div v-if="CurrentOnboarding && CurrentOnboarding.description" class="description">
        {{CurrentOnboarding.description}}
      </div>
      <div class="print-content" ref="contentholder">

      </div>
      <vs-popup title="Add comment to step" :active.sync="InAddingCommentToStepMode" v-if="InAddingCommentToStepMode">
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            Comment:
            <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;"
                      label-placeholder="Comment:"
                      v-model="stepComment" />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full mb-base">
            <vs-button @click="AddCommentToStep(stepComment)">Add</vs-button>
          </div>
        </div>
      </vs-popup>
    </div>
  </div>
</template>
<script>

  import TCVelikClient from '@/TCVelikClient/TCVelikClient';
  import TCVelikBrowserClient from '@/TCVelikBrowserClient/TCVelikBrowserClient';
  import accountsService from '../accounts/accountsService';
  import ImageEditor from '@/views/components/extra-components/imageeditor/ImageEditor.vue';
  import FeatherIcon from "@/components/FeatherIcon.vue";

  export default {
    data() {
      return {
        ShareType: "0",
        InImageZoom: false,
        CurrentZoomImage: '',
        CurrentImgDOM: null,
        InputEmail: "",
        onboardingLink: "",
        password: "",
        tempStepId: "",
        stepComment: "",
        selectedSpace: "",
        IsLoading: true,
        imageChanged: false,
        AfterShare: false,
        CurrentOnboarding: null,
        Spaces: null,
        onboardingSpaces: null,
        InShareOnboardingMode: false,
        InAddOnboardingToSpaceMode: false,
        InAddingCommentToStepMode: false,
        InEmailInputMode: false,
        InAuthorizationMode: false,
        CanShareOnboarding: false,
        GuestUserActions: false,
        PDFDownloadRequestInProgress: false,
        shareReq: {
          onboardingId: this.CurrentOnboarding ? this.CurrentOnboarding.id : 0,
          email: '',
        },
      }
    },

    computed: {
      isInRecording() {
        return window.document.body.getAttribute("notcv") == "true";
      }
    },

    mounted() {
      var instance = this;
      window.addEventListener("message", function (msg) {
        if (msg && msg.data && msg.data.type == "StepCompleted") {
          instance.MarkStepAsComplete(null, msg.data.data);
        }
      });
      document.body.style = 'padding:0px;';
      this.LoadOnboarding();
    },
    methods: {
      LoadOnboarding() {
        var itemId = this.$router.currentRoute.params.onboardingid * 1;
        var instance = this;
        const query = `
                          query GetOnboardings($id: Int) {
                            onboardings(where: { id: {
                                  eq: $id
                              } }) {
                                  id
                                  name
                                  description
                                  rawContent
                              }
                          }
                        `;

        const variables = {
          id: itemId
        };

        const req = {
          query,
          variables
        };

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data && response.data.data && response.data.data.onboardings) {
            instance.$refs.contentholder.innerHTML = response.data.data.onboardings[0].rawContent;
            instance.shareReq.CurrentOnboarding = response.data.data.onboardings[0];
            instance.CurrentOnboarding = response.data.data.onboardings[0];
            instance.AddStepFunctions();
            document.title = instance.CurrentOnboarding.name;
            instance.IsLoading = false;

            var email = localStorage.getItem("pinUserEmail"); // if User with pin.
            if (!email || email.length == 0) {
              var email = JSON.parse(accountsService.getUserFromLocalStorage()).User.Email;
            }

            TCVelikClient.PostRelative("/api/analytics/OpenedOnboarding?OnboardingId=" + itemId + "&OnboardingType=0" + "&UserEmail=" + email);

            instance.$nextTick(function () {

              if (this.isInRecording) {
                var step1 = document.querySelector("[data-type='draggable-item'] p a");
                window.open(step1.href);
              }

              document.querySelectorAll("[data-type='draggable-item'] img")
                .forEach(function (image) {
                  image.classList.add("pointer");
                  image.dataset["url"] = image.src;
                  image.parentNode.style.overflow = "hidden";

                  let scale = 1;
                  let isDragging = false;
                  let startX, startY, currentX = 0, currentY = 0;

                  // Zoom on scroll with CTRL
                  image.addEventListener('wheel', function (e) {
                    if (e.ctrlKey) {
                      e.preventDefault(); // Prevent the default zoom behavior

                      // Zoom in or out
                      const zoomSpeed = 0.3;
                      if (e.deltaY < 0) {
                        scale += zoomSpeed; // Zoom in
                      } else {
                        scale = Math.max(1, scale - zoomSpeed); // Zoom out, with minimum scale of 1
                      }

                      // Apply the scale
                      image.style.transform = `scale(${scale}) translate(${currentX}px, ${currentY}px)`;
                    }
                  });

                  // Panning the image on mouse drag
                  image.addEventListener('mousedown', function (e) {
                    e.preventDefault();
                    isDragging = true;
                    startX = e.clientX - currentX;
                    startY = e.clientY - currentY;
                    image.style.cursor = 'grabbing'; // Change cursor to indicate dragging
                  });

                  document.addEventListener('mousemove', function (e) {
                    if (isDragging) {
                      e.preventDefault();
                      currentX = e.clientX - startX;
                      currentY = e.clientY - startY;

                      // Apply the translation and maintain the zoom scale
                      image.style.transform = `scale(${scale}) translate(${currentX}px, ${currentY}px)`;
                    }
                  });

                  document.addEventListener('mouseup', function () {
                    if (isDragging) {
                      isDragging = false;
                      image.style.cursor = 'grab'; // Reset cursor after dragging
                    }
                  });

                  // Reset cursor when mouse leaves the image
                  image.addEventListener('mouseleave', function () {
                    if (isDragging) {
                      e.preventDefault();
                      isDragging = false;
                      image.style.cursor = 'grab';
                    }
                  });

                  document.addEventListener('mousemove', function (e) {
                    if (isDragging) {
                      currentX = e.clientX - startX;
                      currentY = e.clientY - startY;

                      // Apply the translation and maintain the zoom scale
                      image.style.transform = `scale(${scale}) translate(${currentX}px, ${currentY}px)`;
                    }
                  });

                  document.addEventListener('mouseup', function (e) {
                    isDragging = false;
                  });

                });

              var tools = this.$refs.stepTools;

              instance.AddStepFunctions();

              document.querySelectorAll("[data-type='draggable-item'] p:first-of-type")
                .forEach(function (titleContainer) {
                  titleContainer.addEventListener("mouseover", function () {
                    this.appendChild(tools);
                    tools.classList.remove("invisible");
                    tools.style.top = '2px';
                    tools.style.right = '5px';
                  });
                  titleContainer.addEventListener("mouseout", function () {
                    tools.classList.add("invisible");
                  })
                });
            });
          }
          else if (response && response.data && response.data.errors) {
            alert('There were some errors saving :(');
          }
        });
      },

      AddStepFunctions() {
        const spans = document.querySelectorAll("span.tool");
        spans.forEach((span, index) => {
          if (index === 0) {
            span.addEventListener('click', this.MarkStepAsComplete);
          } else if (index === 1) {
            span.addEventListener('click', this.OpenAddCommentToStepMenu);
          } else if (index === 2) {
            span.addEventListener('click', this.FindElement);
          } else if (index === 3) {
            span.addEventListener('click', this.ShowScreenshot);
          }
        });

      },

      MarkStepAsComplete($event, StepId) {
        if ($event != null) {
          var span = $event.currentTarget;
          var stepWrapper = span.parentNode.parentNode.parentNode;
          StepId = stepWrapper.getAttribute("data-step-id");
        }

        if (stepWrapper == null && StepId && StepId.length > 0) {
          stepWrapper = document.querySelector("[data-step-id='" + StepId + "']");
        }

        var instance = this;
        var email = localStorage.getItem("pinUserEmail"); // if User with pin.

        stepWrapper.querySelector("p:first-of-type").classList.add("bg-success");
        stepWrapper.classList.add("step-completed");

        if (!email || email.length == 0) {
          email = JSON.parse(accountsService.getUserFromLocalStorage()).User.Email;
        }

        TCVelikClient.PostRelative("/api/analytics/OnboardingStep/?OnboardingId=" + this.CurrentOnboarding.id + "&StepId=" + StepId + "&FeedbackType=" + 0 + "&UserEmail=" + email).then(function (response) {
          if (response) {
            //instance.$vs.notify({
            //  title: "Successfully completed step!",
            //  color: "success",
            //  iconPack: "feather",
            //  position: "bottom-center",
            //  icon: "icon-check-circle",
            //});

            stepWrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
            instance.MarkOnboardingDoneIfNeeded();

          }
        }).catch(err => {
          instance.$vs.notify({
            title: "There was a problem completing this step.",
            color: "failure",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        });
      },

      MarkOnboardingDoneIfNeeded() {
        var instance = this;
        var allSteps = document.querySelectorAll("[data-step-id]"); 
        var allCompleted = document.querySelectorAll("[data-step-id].step-completed");
        if (allCompleted.length == allSteps.length) {
          instance.MarkAsCompletedForUser();
        }
      },

      OpenAddCommentToStepMenu($event) {
        var span = $event.currentTarget;
        var stepId = span.parentNode.parentNode.parentNode.getAttribute("data-step-id");
        this.tempStepId = stepId
        this.InAddingCommentToStepMode = true;
      },

      FindElement($event) {
        var parentStep = $event.target.closest("[data-type='draggable-item'");
        var parentStepJson = parentStep.querySelector("p:last-of-type")?.innerText;
        var stepId = parentStep.dataset["stepId"];

        TCVelikBrowserClient.sendMessage({
          action: "FindElement",
          selectorInfo: parentStepJson,
          internalStepId: stepId
        }).then(function (response) {

        }).catch(error => {

        });
      },

      ShowScreenshot($event) {
        var parentStep = $event.target.closest("[data-type='draggable-item'");
        var parentStepScreenshot = parentStep.querySelector("img");
        var src = parentStepScreenshot.src;

        TCVelikBrowserClient.sendMessage({
          action: "ShowScreenShot",
          src: src,
        }).then(function (response) {

        }).catch(error => {

        });
      },

      HasImageChanges(isChanged) {
        this.imageChanged = isChanged;
      },

      AddCommentToStep(comment) {
        var instance = this;
        var email = localStorage.getItem("pinUserEmail"); // if User with pin.
        if (!email || email.length == 0) {
          email = JSON.parse(accountsService.getUserFromLocalStorage()).User.Email;
        }
        TCVelikClient.PostRelative("/api/analytics/OnboardingStep/?OnboardingId=" + this.CurrentOnboarding.id + "&StepId=" + instance.tempStepId + "&FeedbackType=" + 1 + "&Reason=" + comment + "&UserEmail=" + email).then(function (response) {
          if (response) {
            instance.tempStepId = "";
            instance.$vs.notify({
              title: "Added comment.",
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
          }
        }).catch(err => {
          instance.$vs.notify({
            title: "There was a problem adding the comment.",
            color: "failure",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        });
      },

      MarkAsCompletedForUser() {
        var instance = this;
        var email = localStorage.getItem("pinUserEmail"); // if User with pin.
        if (!email || email.length == 0) {
          var email = JSON.parse(accountsService.getUserFromLocalStorage()).User.Email;
        }

        TCVelikClient.PostRelative("/api/analytics/OpenedOnboarding?OnboardingId=" + this.CurrentOnboarding.id + "&OnboardingType=1" + "&UserEmail=" + email).then(function (response) {
          if (response) {
            instance.$vs.notify({
              title: "Successfully completed onboarding!",
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
          }
        }).catch(err => {
          instance.$vs.notify({
            title: "There was a problem saving your onboarding.",
            color: "failure",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        });
      },

    },
    components: {
      ImageEditor,
      FeatherIcon
    }
  }
</script>
<style>
  body {
    background: #fff;
    padding: 20px;
  }
  /*
  .print-content {
    height: 500px;
  }*/

  .step-completed {
      background:none !important;
  }

  .onboarding-recorder.email .vs-collapse-item {
    background: white !important;
  }

  .disabled-class {
    pointer-events: none;
    opacity: 0.5;
  }

  .pointer {
    cursor: pointer;
  }

  .side-kick {
    position: absolute;
    left: 108px;
    transform: rotate(-90deg);
    top: 90px;
  }

    .side-kick img {
      float: left;
      margin-right: 10px;
      width: 40px;
    }

  @media only screen and (max-width: 1200px) {
    .side-kick {
      padding: 10px;
      width: 200px;
      position: absolute;
      /*transform: rotate(0deg);*/
      left: -20px;
    }
  }

  @media print {
    .side-kick {
      padding: 10px;
      width: 200px;
      position: absolute;
      left: -20px;
    }
  }

  .onboarding-recorder.email .vs-collapse-item--header {
    /*font-size: 20px;
    color: black;
    margin-bottom: 10px !important;
    margin-top: 10px !important;*/
    background: white !important;
  }

  .onboarding-recorder.email .step-tools {
    display: none !important;
  }

  .onboarding-recorder.email .icon-header {
    display: none !important;
  }

  .onboarding-recorder.email .screenshot {
    max-width: 300px !important;
  }

  .pointer {
    cursor: pointer;
  }

  .commands {
    position: fixed;
    bottom: 0px;
  }

  .full-height {
    height: 100%;
  }

  img.screenshot {
    max-width: 80%;
    opacity: 0.8;
  }

  .onboarding-recorder .vs-collapse-item--header {
    background: #efefef;
    margin-bottom: 10px;
  }

  .delete-button {
    background: url('/images/icons/tiptap/delete.svg');
    width: 24px !important;
    height: 24px !important;
    min-height: 24px;
    min-width: 24px;
    background-repeat: no-repeat;
    cursor: pointer;
  }

  [data-type='draggable-item'] {
    padding: 0.5rem;
    margin: 0.5rem 0;
    border-radius: 0.5rem;
    /*background: #fde2ff !important;*/
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05), 0px 10px 20px rgba(0, 0, 0, 0.1),;
    background: linear-gradient(181deg, #efefef, #cdcdcd);
  }

    [data-type='draggable-item'].step-completed p:first-of-type {
      display: block !important;
      color:white;
    }

    [data-type='draggable-item'].step-completed p:first-of-type a {
      color: white;
    }

    [data-type='draggable-item'].step-completed p {
        display:none;
    }

    [data-type=draggable-item] p:first-of-type {
      padding: 10px;
      border: 1px solid #efefef;
      background: #efefef;
      border-radius: 12px;
    }

  [data-type='draggable-item'] img {
    margin-top: 20px;
    max-width: 100%;
  }

  [data-type='draggable-item'].collapsed {
    max-height: 3rem !important;
    overflow: hidden;
  }

  .full-height ol {
    padding: 10px;
    margin-left: 20px;
    font-size: 20px;
  }

    .full-height ol li {
    }

  [data-type='draggable-item'] p:first-of-type('p') {
    font-size: 40px;
  }

  .layout--full-page {
    max-width: 800px;
    margin: 0 auto;
  }

  .drag-handle {
    flex: 0 0 auto;
    position: relative;
    width: 1rem;
    height: 1rem;
    top: 0.5rem;
    margin-right: 0.5rem;
    cursor: grab;
    background-image: url('data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 16"><path fill="gray" fill-opacity="0.2" d="M4 14c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zM2 6C.9 6 0 6.9 0 8s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6C.9 0 0 .9 0 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" /></svg>');
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  }

  .tt-select {
    width: auto;
    height: 32px;
    display: inline-block;
    margin-right: 10px;
    cursor: pointer;
    text-align: center;
    padding: 3px;
    border-radius: 5px;
    border: 1px solid grey;
    background: #fff;
    color: #000;
    cursor: pointer;
    margin-right: 3px;
    min-width: 33px;
    height: 33px !important;
    margin-top: 10px
  }

  .content {
    flex: 1 1 auto;
  }

  p {
    font-size: 20px;
  }

  h1 {
    margin-top: 20px;
    margin-bottom: 20px;
  }

    h1.title {
      font-size: 40px;
      font-weight: 900;
    }

  div.description {
    font-size: 20px;
    margin-bottom: 50px;
  }

  [data-type='draggable-item'] p:last-child {
    display: none;
  }

  [data-type='draggable-item'] p:first-of-type {
    position: relative;
  }

  .tools {
    position: absolute;
    background:#efefef !important;
    border:1px solid silver;
    border-radius:3px;
    padding-right:5px;
  }

    .tools .tool {
      margin-left: 12px;
      margin-top: 12px;
      cursor: pointer;
      margin-right: 5px;
    }

  @media print {
    .pdf-hide {
      display: none;
    }
  }
</style>
